import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { CustomerForm, CustomerFormType } from './CustomerForm'
import { createCustomer } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Customers',
    path: '/customers'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddCustomer = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createCustomer({
        company: form.company,
        prefix: form.prefix,
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,
        salesUserId: form.salesUser.id,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip
      })
      createToast('success', 'Customer created')
      navigate('/customers')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Customer</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <CustomerForm
              type={CustomerFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
